import { render, staticRenderFns } from "./ImptBsnesAgencInfoList.vue?vue&type=template&id=67bccf6d"
import script from "./ImptBsnesAgencInfoList.vue?vue&type=script&lang=js"
export * from "./ImptBsnesAgencInfoList.vue?vue&type=script&lang=js"
import style0 from "./ImptBsnesAgencInfoList.vue?vue&type=style&index=0&id=67bccf6d&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67bccf6d')) {
      api.createRecord('67bccf6d', component.options)
    } else {
      api.reload('67bccf6d', component.options)
    }
    module.hot.accept("./ImptBsnesAgencInfoList.vue?vue&type=template&id=67bccf6d", function () {
      api.rerender('67bccf6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/ImptBsnesAgencInfoList.vue"
export default component.exports